import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginContext,
    PluginHeuristicsRegistry
} from '../../types'
import {horizontalAlignmentHeuristics, verticalAlignmentHeuristics} from './heuristicsDefinitions'
import {createAdaptiveHeuristic} from '../common'

export const createPlugin = ({stages, readOnlyExtensionAPI}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const horizotalAlignComponent = (componentStageData: ComponentStageData, contextHelper: PluginContext) => {
        const heuristicToApply = horizontalAlignmentHeuristics.find(({predicate}) =>
            predicate(componentStageData, contextHelper, readOnlyExtensionAPI)
        )

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)
        return {
            appliedHeuristics: [heuristicToApply.heuristicCode]
        }
    }

    const verticalAlignComponent = (componentStageData: ComponentStageData, contextHelper: PluginContext) => {
        const heuristicToApply = verticalAlignmentHeuristics.find(({predicate}) =>
            predicate(componentStageData, contextHelper, readOnlyExtensionAPI)
        )

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)
        return {
            appliedHeuristics: [heuristicToApply.heuristicCode]
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.TRANSFORM_STYLE, createAdaptiveHeuristic(horizotalAlignComponent))
        registry.register(stages.TRANSFORM_STYLE, createAdaptiveHeuristic(verticalAlignComponent))
    }

    const name = 'alignComponent'
    return {register, name}
}
